import Vue from 'vue'

// Components
import "./components";

// Plugins
import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";


import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'

// Sync store with router
sync(store, router);



store.state.API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
vuetify.framework.theme.themes.light.primary = process.env.VUE_APP_COLOR_PRIMARY


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

